<template>
  <va-form :id="id" :item="item">
    <v-row justify="center">
      <v-col sm="6">
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2">
              {{ title }}
            </div>
          </template>
          <v-card-text>
            <va-boolean-input source="status"></va-boolean-input>
            <va-text-input source="title"></va-text-input>
            <va-rich-text-input source="description"></va-rich-text-input>
            <va-date-input source="publication_date"></va-date-input>
            <va-file-input
              lg="4"
              preview
              source="file"
            >
            </va-file-input>
            <va-boolean-input source="featured"></va-boolean-input>
          </v-card-text>
          <va-save-button></va-save-button>
        </base-material-card>
      </v-col>
    </v-row>
  </va-form>
</template>

<script>

export default {
  props: ["id", "title", "item"],
};
</script>
